import styled from "styled-components";

const Copy = styled.div`
  color: ${({ color, theme }) => theme.colors[color]};
  font-size: ${({ size }) => `${size}rem`};
  font-weight: ${({ weight }) => weight || "400"};
  height: ${({ height }) => height};
  line-height: ${({ lineHeight, size }) => lineHeight || `${size + 0.2}rem`};
  padding: ${({ padding }) => padding};
  margin: ${({ margin }) => margin};
  min-height: ${({ minHeight }) => minHeight};
  min-width: ${({ minWidth }) => minWidth};
  max-height: ${({ maxHeight }) => maxHeight};
  max-width: ${({ maxWidth }) => maxWidth};
  text-align: ${({ align }) => align};
  text-transform: ${({ uppercase }) => uppercase && "uppercase"};
  width: ${({ width }) => width};

  ${({ verticalAlignment }) =>
    verticalAlignment && `display: flex; align-items: ${verticalAlignment};`}
`;

export default Copy;
